import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AdAttribution = lazy(() => import('../AdAttribution'));

const adAttributionRoute: RouteObject = {
  path: '/ad-attribution',
  element: <AdAttribution />,
};

export default adAttributionRoute;
